import { render, staticRenderFns } from "./VDocumentTiff.vue?vue&type=template&id=343978fc&"
import script from "./VDocumentTiff.vue?vue&type=script&lang=js&"
export * from "./VDocumentTiff.vue?vue&type=script&lang=js&"
import style0 from "./VDocumentTiff.vue?vue&type=style&index=0&id=343978fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports